import { PdfExportService } from '../../../../services/export-pdf/pdf-export.service';
import { UserService } from '../../../../services/user.service';
/**
 * This component is used for printing only
*/
var ListPlatformReachComponent = /** @class */ (function () {
    function ListPlatformReachComponent(pdfService, userService) {
        this.pdfService = pdfService;
        this.userService = userService;
        this.platformReachs = [];
        this.forPayingUser = false;
    }
    Object.defineProperty(ListPlatformReachComponent.prototype, "showFallbackView", {
        get: function () {
            return this.platformReachs.length === 0
                || (this.forPayingUser && this.userService.isFreeUser() && !this.userService.isAdmin);
        },
        enumerable: true,
        configurable: true
    });
    ListPlatformReachComponent.prototype.ngAfterViewInit = function () {
        this.pdfService.incrementNumberReportReady(ListPlatformReachComponent.COMPONENT_NAME);
    };
    ListPlatformReachComponent.COMPONENT_NAME = 'ListPlatformReachComponent';
    return ListPlatformReachComponent;
}());
export { ListPlatformReachComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/list-platform-reach/list-platform-reach.component.ts.pre-build-optimizer.js